import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {ButtonComponent} from '@sms-ir/ui-components';

import {LoadingService} from '@shared/services/loading.service';

@Component({
  selector: 'app-maintenance',
  standalone: true,
  imports: [ButtonComponent],
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaintenanceComponent implements OnInit {
  constructor(
    private loadingService: LoadingService,
  ) {
    this.loadingService.setModalLoadingState(false);
  }

  ngOnInit(): void {
  }

  retry(): void {
    window.location.href = '/';
  }
}
